import { FormControl, FormGroup } from '@angular/forms';

export const CONSTS = {
  HEADER: $localize`Non-UPS Barcode Extract`,
  DATE_LABEL: $localize`Date`,
};

export const REPORT_FILE_NAME = 'Non-Barcode-Report';

type NonUpsBarcodeFormField = {
  date: FormControl<Date>;
};

export type NonUpsBarcodeFormGroup = FormGroup<NonUpsBarcodeFormField> | null;
